import React from 'react';
import { StarIcon } from 'lucide-react';
export function Divider() {
  return <div className="flex items-center justify-center w-full py-12 opacity-70" data-id="element-349">
      <div className="h-px bg-gradient-to-r from-transparent via-delux-gold to-transparent w-1/3" data-id="element-350"></div>
      <StarIcon className="w-4 h-4 text-delux-gold mx-4" data-id="element-351" />
      <div className="h-px bg-gradient-to-r from-delux-gold via-delux-gold to-transparent w-1/3" data-id="element-352"></div>
    </div>;
}